/** Textos del pago multipersona y del detalle del pago. Código en inglés, pantalla en español. */
const S = {
	title: "Pago Multipersona",
	button: "Pago Multipersona",
	step1: "Datos del Pago",
	step2: "Repartir",
	total: "Total Recibido",
	method: "Método de Pago",
	account: "Cuenta Receptora",
	date: "Fecha de Pago",
	reference: "Referencia",
	referenceHint: "Se comprueba contra los pagos de esta cuenta antes de seguir.",
	payer: "Quién Paga",
	payerPlaceholder: "Nombre de quien entregó el dinero",
	payerPhone: "Teléfono de Quien Paga",
	notes: "Nota General",
	notesPlaceholder: "Se copia a cada persona; se puede cambiar por persona en el paso 2.",
	attachments: "Comprobante",
	attachmentsHint: "Uno solo para todo el pago; cada movimiento lo muestra.",
	next: (total: string) => `Repartir ${total} →`,
	back: "← Volver",
	addPerson: "+ Agregar Persona",
	searchPlaceholder: "Buscar por nombre o correlativo",
	noResults: "Sin resultados en este plantel.",
	alreadyAdded: "Ya está en el pago.",
	remove: "Quitar",
	nothingToPay: "No tiene conceptos pendientes que se puedan cobrar.",
	loadingItems: "Cargando conceptos...",
	assigned: "Asignado",
	personNote: "Nota",
	personNotePlaceholder: "Igual que la nota general",
	lockedAmount: "Con dos o más conceptos el monto va completo (no hay pago parcial).",
	pendingInvoice: (id: number) => `Factura ${id} Pendiente`,
	invoiceHint: "Se abona a la factura tal cual; sin descuentos.",
	partial: (left: string) => `Pago parcial · quedan ${left}`,
	received: "Recibido",
	assignedTotal: "Asignado",
	difference: "Diferencia",
	missing: (n: string) => `faltan ${n} por asignar`,
	over: (n: string) => `asignaste ${n} de más`,
	submit: (n: number) => `Registrar ${n} ${n === 1 ? "Movimiento" : "Movimientos"}`,
	needTwo: "Un pago multipersona lleva al menos dos personas.",
	needItems: "Cada persona necesita al menos un concepto.",
	discount: "desc.",
	close: "Cerrar",
	done: (id: number) => `Pago ${id} registrado.`,
	downloadReceipt: "Ver Recibo",
	validation: {
		total: "Escribe el total que entró.",
		method: "Elige el método de pago.",
		account: "Elige la cuenta receptora.",
		date: "Falta la fecha de pago.",
		reference: "La referencia debe tener al menos 4 caracteres.",
		notes: "La nota debe tener al menos 10 caracteres.",
		files: "Este método exige comprobante."
	},
	receipt: {
		title: "Pago",
		movements: "Movimientos",
		status: "Estado",
		of: "de",
		payer: "Pagó",
		registered: "Registró",
		cancelWhole: "Anular Pago Completo",
		cancelPrompt: "Anular el Pago Completo",
		cancelHint: "Anular un pago es decir que el dinero no entró: se anulan todos sus movimientos. Si el dinero sí entró pero se repartió mal, eso se corrige aparte.",
		cancelPlaceholder: "Por qué se anula (transferencia rebotada, comprobante falso...)",
		cancelled: "Pago anulado.",
		cancelledBy: "Anulado por",
		confirm: "Confirmar",
		partOf: (label: string, receipt: string, count: number, total: string) => `Movimiento ${label} del pago ${receipt} · ${count} movimientos · ${total}`,
		view: "Ver",
		repeatedRef: "Referencia Repetida (BAC)"
	}
};

export default S;
